export default {
  "path": "/demo/html2canvas",
  "meta": {
    "name": "demo-Html 转 Canvas",
    "title": "Html 转 Canvas",
    "isComponentDoc": true,
    "category": "Introduce"
  }
};